import React, {useEffect, useRef, useState} from 'react';
import {Input} from "antd";
import {PlusOutlined, SearchOutlined} from "@ant-design/icons";
import print from "../../../../../../icons/print.png";
import pdf from "../../../../../../icons/pdf.png";
import excel from "../../../../../../icons/excel.png";
import {seasonMonths} from "../../../../../../components/functions/Month";
import axios from "axios";
import {header} from "../../../../../../components/api/Header";
import {user_data} from "../../../../../../components/functions/usr";
import {NavLink} from "react-router-dom";
import {ExcelPrint, Pdf} from "../../../../../../components/functions/Print";
import {useReactToPrint} from "react-to-print";
import { getEnv } from "../../../../../../lib/env";

function Table() {
    const conponentPDF= useRef();
    const [year, setYear] = useState(new Date().toISOString().slice(0,4))
    const [lyear, setLyear] = useState(year)
    const [season, setSeason] = useState('veg')
    const setSearch = (text) => {
        console.log(text)
    }
    const [data, setData] = useState([])
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitdaryo/index?year="+year+"&season="+season+"&daryo=amu", header())
                .catch(e=>{
                    console.log("Xato",e)
                    alert("Server bilan aloqa yo'q")
                })
            if(res){
                setData(res.data.data)
            }
        }
        fetchData()
    },[year,season])
    const generatePDF= useReactToPrint({
        content: ()=>conponentPDF.current,
        documentTitle:"Userdata",
        // onAfterPrint:()=>alert("Data saved in PDF")
    });
    return (
        <>
            <div className="table-content-top">
                <div className="table-top-left">
                    <Input
                        prefix={<SearchOutlined className="site-form-item-icon" />}
                        placeholder="Search"
                        onChange={e=>setSearch(e.target.value)}
                    />
                </div>
                <ul className="table-top-right">
                    {
                        user_data()?user_data().region_id == 16 ?
                            <li>
                                <NavLink to="/limit/daryolar/amudaryo/add" className="btn btn-sm btn-outline-primary d-flex align-items-center">
                                    Ma'lumot kiritish &nbsp;&nbsp;&nbsp;<PlusOutlined/>
                                </NavLink>
                            </li>
                            :null:null
                    }
                    <li className="d-flex align-items-center">
                        <input type="number" className="form-control form-control-sm" min={2015} max={parseInt(new Date().toISOString().slice(0,4))+2} value={lyear} onChange={e=>setLyear(e.target.value)}/>
                        &nbsp;&nbsp;&nbsp;
                        <button className="btn btn-sm btn-outline-primary" onClick={()=>setYear(lyear)}>Ok</button>
                    </li>
                    <li>
                        <select className="form-select form-select-sm" onChange={e=>setSeason(e.target.value)} value={season}>
                            <option value="veg">Sug'orish mavsumi</option>
                            <option value="noveg">Nosug'orish mavsumi</option>
                        </select>
                    </li>
                    <li>
                        <button className="btn p-0" onClick={() => generatePDF()}>
                            <img src={print} alt="404"/>
                        </button>
                    </li>
                    <li>
                        <button  onClick={() => Pdf('tblData')} className="btn p-0">
                            <img src={pdf} alt="404"/>
                        </button>
                    </li>
                    <li>
                        <button className="btn p-0" onClick={()=>ExcelPrint("Daryo havzalar", "sheet 1", "tblData")}>
                            <img src={excel} alt="404"/>
                        </button>
                    </li>
                </ul>
            </div>
            <div className="table-responsive tableFixHead">
                <div ref={conponentPDF} style={{width:'100%'}}>
                <table id="tblData" className="table table-bordered table-style">
                    <thead>
                    <tr>
                        <th colSpan={21}>O‘zbekiston Respublikasi bo‘yicha {year}-yilning {season == 'noveg' ? 'no' :null}sug‘orish mavsumi  uchun Amudaryo o‘zani bo‘yicha suv olish limiti</th>
                    </tr>
                    <tr>
                        <th rowSpan={2} scope="col">№</th>
                        <th rowSpan={2} scope="col" >Kanallar, irrigatsiya tizimlari havza boshqarmasi</th>
                        <th rowSpan={2} scope="col">Suv hajmi, mln.m<sup>3</sup></th>
                        {
                            seasonMonths(season).map((s,i)=>{
                                return <th key={i} colSpan={3}>{s}</th>
                            })
                        }
                    </tr>
                    <tr>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                    </tr>
                    </thead>
                    {
                        data.length > 0?
                            data.map((d,i) => {
                                return <tbody key={i}>
                                <tr>
                                    <th scope="col" style={{width:'20px'}}>{i+1}</th>
                                    <th scope="col" style={{width:'200px'}}>{d.name}</th>
                                    <th scope="col" style={{width:'50px'}}><b>{d.sarf}</b></th>
                                    {
                                        Array(18).fill().map((p,ind)=>{
                                            return <th scope="col" key={ind}>{d['d'+(ind+1)]}</th>
                                        })
                                    }
                                </tr>

                                </tbody>
                            })
                            :null
                    }
                </table>
                </div>
            </div>
        </>
    );
}

export default Table;

